import { useState } from "react";
import { GetRechnungDetailsDto } from "../../../../../api-client";

/**
 * Custom hook for managing all transaction dialog states
 * Centralizes dialog state management following SRP
 */
export const useTransactionDialogs = () => {
  // Dialog open states
  const [cancelCashDialogOpen, setCancelCashDialogOpen] = useState(false);
  const [cancelECDialogOpen, setCancelECDialogOpen] = useState(false);
  const [cancelBankTransferDialogOpen, setCancelBankTransferDialogOpen] =
    useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [payDialogOpen, setPayDialogOpen] = useState(false);

  // Dialog data states
  const [transactionToDelete, setTransactionToDelete] = useState<any>(null);
  const [deleteRechnung, setDeleteRechnung] =
    useState<GetRechnungDetailsDto | null>(null);
  const [selectedRechnung, setSelectedRechnung] =
    useState<GetRechnungDetailsDto | null>(null);

  const closeAllDialogs = () => {
    setCancelCashDialogOpen(false);
    setCancelECDialogOpen(false);
    setCancelBankTransferDialogOpen(false);
    setDeleteDialogOpen(false);
    setPayDialogOpen(false);
    setTransactionToDelete(null);
    setDeleteRechnung(null);
  };

  return {
    // Cash cancellation
    cancelCashDialogOpen,
    setCancelCashDialogOpen,

    // EC cancellation
    cancelECDialogOpen,
    setCancelECDialogOpen,

    // Bank transfer cancellation
    cancelBankTransferDialogOpen,
    setCancelBankTransferDialogOpen,

    // Rechnung deletion
    deleteDialogOpen,
    setDeleteDialogOpen,
    deleteRechnung,
    setDeleteRechnung,

    // Payment dialog
    payDialogOpen,
    setPayDialogOpen,
    selectedRechnung,
    setSelectedRechnung,

    // Generic transaction to delete
    transactionToDelete,
    setTransactionToDelete,

    // Utility
    closeAllDialogs,
  };
};
